<!--单选组-->
<template>
  <el-radio-group
    v-model="value"
    v-bind="$attrs"
    :id="'c' + formItemMeta.columnId"
    :name="'c' + formItemMeta.columnId"
    :title="title"
    :clearable="clearable"
  >
    <el-radio
      v-for="item in optionList"
      v-bind="$attrs"
      :key="'radio' + item.value"
      :label="item.value"
      :disabled="item.disabled"
    >
      {{item.label}}
    </el-radio>
  </el-radio-group>
  <circle-close-filled v-if="clearable"
    style="width: 1.2em; height: 1.2em; margin-top: 0px; margin-left: 5px;cursor: pointer;"
    @click.stop="myclear" 
  />
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  // import { ElRadio, ElRadioGroup } from 'element-plus'
  import { CircleCloseFilled } from '@element-plus/icons-vue'
  // 引入组件需要的属性 引入表单子控件的管理类
  import { itemProps, itemController, loadController } from '../map'

  export default defineComponent({
    name: 'nf-el-from-item-radios',
    inheritAttrs: false,
    components: {
      // ElRadio, ElRadioGroup,
      CircleCloseFilled
    },
    props: {
      ...itemProps, // 基础属性
      colName: String, // 变更字段名称
      modelValue: [Array]
    },
    emits: ['update:modelValue'],
    setup (props, context) {
      
      // 从后端获取数据
      const { loadDict } = loadController(props)
      loadDict()

      const {
        value
      } = itemController(props, context.emit)

      const myclear = () => {
        value.value = null
      }

      return {
        value,
        myclear
      }
    }
  })
</script>
